/**
 * Experience Engine™ presentation configuration.
 *
 * These values tune PRESENTATION ONLY — pacing, timing, motion. They are
 * not canon and carry no scientific meaning; canonical copy, flows, and
 * validation rules live in the WeKIT-Command-Center (v1.0.0, locked).
 *
 * Keep every value here explainable in one sentence.
 */

export const MIRROR_MOMENT = {
  /**
   * Pause before each reveal step: line 2, line 3 (a longer breath before
   * the emotional crescendo), then the Continue action.
   * Total ≈ 5.5s — the canon's "five seconds that set the emotional tone".
   */
  stepDelaysMs: [1900, 2400, 1200] as readonly number[],
} as const;
